// import React from 'react';
// import { Link } from 'react-router-dom';
// import pattern7 from '../assets/images/background/pattern-7.png';
// import pattern8 from '../assets/images/background/pattern-8.png';
// import logoImage from '../assets/images/logo-2.png'; 
// import postThumbImage_3 from '../assets/images/resource/post-thumb-4.png'; 
// import postThumbImage_4 from '../assets/images/resource/post-thumb-3.png'; 

// const Footer = ({ }) => {
//     return (
// <>
// {/* <!-- Main Footer --> */}
//     <footer className="main-footer">
// 	<div className="pattern-layer-one" style={{ backgroundImage: `url(${pattern7})` }}></div>
// 	<div className="pattern-layer-one" style={{ backgroundImage: `url(${pattern8})` }}></div>	
// 		{/* <!--Waves end--> */}
//     	<div className="auto-container">
//         	{/* <!--Widgets Section--> */}
//             <div className="widgets-section">
//             	<div className="row clearfix">
//                     {/* <!-- Column --> */}
//                     <div className="big-column col-lg-6 col-md-12 col-sm-12">
// 						<div className="row clearfix">
//                         	{/* <!-- Footer Column --> */}
//                             <div className="footer-column col-lg-7 col-md-6 col-sm-12">
//                                 <div className="footer-widget logo-widget">
// 									<div className="logo">
// 										<a href="index.html"><img src={logoImage} alt="Logo" /></a>
// 									</div>
// 									<div className="text">Global IT experts in hardware, networking, and software. With 1+ year experience and 10 projects, we drive business growth through tech.</div>
// 									{/* <!-- Social Box --> */}
// 									<ul className="social-box">
// 										<li><a href="#" className="fa fa-facebook-f"></a></li>
// 										<li><a href="#" className="fa fa-linkedin"></a></li>
// 										<li><a href="#" className="fa fa-twitter"></a></li>
// 										<li><a href="#" className="fa fa-google"></a></li>
// 									</ul>
// 								</div>
// 							</div>
							
// 							{/* <!-- Footer Column --> */}
//                             <div className="footer-column col-lg-5 col-md-6 col-sm-12">
//                                 <div className="footer-widget links-widget">
// 									<h5>Quick Links</h5>
// 									<ul className="list-link">
// 										<li><a href="/services">Managed IT services</a></li>
// 										<li><a href="/contact">IT support & helpdesk</a></li>
// 										<li><a href="/contact">Custom Software</a></li>
// 										<li><a href="/contact">Free Consultation</a></li>
// 										<li><a href="/services">Our Business Growth</a></li>
// 									</ul>
// 								</div>
// 							</div>
							
// 						</div>
// 					</div>
					
// 					{/* <!-- Column --> */}
//                     <div className="big-column col-lg-6 col-md-12 col-sm-12">
// 						<div className="row clearfix">
// 							{/* <!-- Footer Column --> */}
// 							{/* <div className="footer-column col-lg-6 col-md-6 col-sm-12">
// 								<div className="footer-widget news-widget">
// 									<h5>Recent Project</h5>
// 									<div className="widget-content">
// 										<div className="post">
// 											<div className="thumb"><a href="https://www.scrappertool.com/"><img src={postThumbImage_3} alt="" /></a></div>
// 											<h6><a href="/project/project-scrapper-tool">Smart Data with Scraper Tech</a></h6>
// 											<span className="date">May 01, 2025</span>
// 										</div>
// 										<div className="post">
// 											<div className="thumb"><a href="https://full2sms.in/"><img src={postThumbImage_4} alt="" /></a></div>
// 											<h6><a href="/project/Project-full2sms-Tool">Full2SMS: Smooth & Secure Payouts</a></h6>
// 											<span className="date">May 01, 2020</span>
// 										</div>
// 									</div>
// 								</div>
// 							</div> */}
							
// 							{/* <!-- Footer Column --> */}
// 							<div className="footer-column col-lg-12 col-md-12 col-sm-12">
// 								<div className="footer-widget contact-widget">
// 									<h5>Contact Us</h5>
// 									<ul>
// 										<li>
// 											<span className="icon flaticon-placeholder-2"></span>
// 											<strong>Address</strong>
// 											Privilon, SG Hwy, AHM, IND
// 										</li>
// 										<li>
// 											<span className="icon flaticon-phone-call"></span>
// 											<strong>Phone</strong>
// 											<a href="tel:+9163523 73580">+ 91 63523 73580</a>
// 										</li>
// 										<li>
// 											<span className="icon flaticon-email-1"></span>
// 											<strong>E-Mail</strong>
// 											<a href="mailto:swiftmazetech@gmail.com">swiftmazetech@gmail.com</a>
// 										</li>
// 									</ul>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
			
// 			{/* <!-- Footer Bottom --> */}
// 			<div className="footer-bottom">
// 				<div className="auto-container">
// 					<div className="row clearfix">
// 						{/* <!-- Column --> */}
// 						<div className="column col-lg-6 col-md-12 col-sm-12">
// 							<div className="copyright">Copyright &copy; 2020 SwiftMaze Tech Pvt. Ltd. All Rights Reserved.</div>
// 						</div>
// 						{/* <!-- Column --> */}
// 						<div className="column col-lg-6 col-md-12 col-sm-12">
// 							<ul className="footer-nav">
// 								<li><Link to="/about">About Us</Link></li>
// 								<li><Link to="/services">Services</Link></li>
// 								<li><Link to="/privcy-policy">Privacy</Link></li>
// 							</ul>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	</footer>

// </>
// );
// };

// export default Footer;

import React from 'react';
import { Link } from 'react-router-dom';
import pattern7 from '../assets/images/background/pattern-7.png';
import pattern8 from '../assets/images/background/pattern-8.png';
import logoImage from '../assets/images/logo-2.png';

const Footer = () => {
  return (
    <>
      {/* Main Footer */}
      <footer className="main-footer">
        <div
          className="pattern-layer-one"
          style={{ backgroundImage: `url(${pattern7})` }}
        ></div>
        <div
          className="pattern-layer-two"
          style={{ backgroundImage: `url(${pattern8})` }}
        ></div>

        <div className="auto-container">
          {/* Widgets Section */}
          <div className="widgets-section">
            <div className="row clearfix">

              {/* ========================= */}
              {/* 1️⃣ DESCRIPTION SECTION   */}
              {/* ========================= */}
              <div className="footer-column col-lg-4 col-md-6 col-sm-12">
                <div className="footer-widget logo-widget">
                  <div className="logo mb-3">
                    <a href="/">
                      <img src={logoImage} alt="Logo" />
                    </a>
                  </div>

                  <div className="text">
                    SwiftMaze Tech is a digital solutions company providing software development, website design & development, and digital marketing services to help businesses build strong systems and achieve long-term growth.
                  </div>

                  <div className="footer-gst-badge" aria-label="GST registered business, GSTIN 24ABNCS8168C1Z2">
                    <span className="footer-gst-icon fa fa-check-circle" aria-hidden="true"></span>
                    <span>
                      <strong>GST Registered Business</strong>
                      <small>GSTIN: 24ABNCS8168C1Z2</small>
                    </span>
                  </div>

                  {/* Social Box */}
                  <ul className="social-box mt-3">
                    {/* <li><a href="#" className="fa fa-facebook-f"></a></li>
                    <li><a href="#" className="fa fa-linkedin"></a></li>
                    <li><a href="#" className="fa fa-twitter"></a></li>
                    <li><a href="#" className="fa fa-google"></a></li> */}
                <li><a href="https://www.facebook.com/swiftmazetech/" className="fa fa-facebook-f" aria-label="Facebook"></a></li>
                <li><a href="https://www.instagram.com/swiftmazetech" className="fa fa-instagram" aria-label="Instagram"></a></li>
                <li><a href="https://www.youtube.com/@SwiftMazeTech" className="fa fa-youtube" aria-label="YouTube"></a></li>
                <li><a href="https://www.linkedin.com/company/swiftmaze-tech-pvt-ltd/" className="fa fa-linkedin" aria-label="LinkedIn"></a></li>
            
                  </ul>
                </div>
              </div>

              {/* ========================= */}
              {/* 2️⃣ QUICK LINKS SECTION   */}
              {/* ========================= */}
              <div className="footer-column col-lg-4 col-md-6 col-sm-12">
                <div className="footer-widget links-widget">
                  <h5>Quick Links</h5>

                  <ul className="list-link">
                       <li><Link to="/services/hire-chrome-extension-developer/">Hire Chrome Extension Developer</Link></li>
                       <li><Link to="/services/web-development/">Web Development</Link></li>
                       <li><Link to="/services/erp-development/">ERP system</Link></li>
                       <li><Link to="/services/crm-development/">CRM System</Link></li>
                       <li><Link to="/services/website-development-modasa/">Website Development Modasa</Link></li>
                       <li><a href="https://www.swiftmazetech.com/blog/">Blog</a></li>
                  </ul>
                </div>
              </div>

              {/* ========================= */}
              {/* 3️⃣ CONTACT US SECTION    */}
              {/* ========================= */}
              <div className="footer-column col-lg-4 col-md-6 col-sm-12">
                <div className="footer-widget contact-widget">
                  <h5>Contact Us</h5>

                  <ul>
                   <li>
  <span className="icon flaticon-placeholder-2"></span>
  <strong>Address</strong>

  <a
    className="address-lines"
    href="https://maps.app.goo.gl/DUQUVbVo5rRTTtgE7"
    target="_blank"
    rel="noopener noreferrer"
  >
    1st floor, Ayesha Complex, College Rd, Next to Dawat Hotel, Modasa, Gujarat 383315
  </a>
</li>


                    <li>
                      <span className="icon flaticon-phone-call"></span>
                      <strong>Phone</strong>
                      <a href="tel:+919978623133">+91 99786 23133</a>
                    </li>

                    <li>
                      <span className="icon flaticon-email-1"></span>
                      <strong>Email</strong>
                      <a href="mailto:swiftmazetech@gmail.com">
                        swiftmazetech@gmail.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="auto-container">
              <div className="row clearfix">
                <div className="column col-lg-6 col-md-12 col-sm-12">
                  <div className="copyright">
                    © 2026 SwiftMaze Tech Pvt. Ltd. All Rights Reserved.
                  </div>
                </div>

                <div className="column col-lg-6 col-md-12 col-sm-12">
                  <ul className="footer-nav">
                    <li><Link to="/about/">About Us</Link></li>
                    <li><Link to="/services/">Services</Link></li>
                    <li><Link to="/privacy-policy/">Privacy Policy</Link></li>
                    <li><Link to="/terms-and-conditions/">Terms & Conditions</Link></li>
                    <li><Link to="/refund-policy/">Refund Policy</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
      </footer>
    </>
  );
};

export default Footer;
